var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "dummy-scout-form",
    {
      attrs: {
        "is-modified": !!_vm.isReviewSaved,
        "data-test": "is-review-saved",
        label: "行動ターゲティング",
      },
    },
    [
      _c("div", { staticClass: "boss-layout boss-layout-start" }, [
        _c("label", { staticClass: "boss-checkbox" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.isReviewSaved,
                expression: "isReviewSaved",
              },
            ],
            staticClass: "boss-input-checkbox",
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.isReviewSaved)
                ? _vm._i(_vm.isReviewSaved, null) > -1
                : _vm.isReviewSaved,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.isReviewSaved,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.isReviewSaved = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.isReviewSaved = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.isReviewSaved = $$c
                }
              },
            },
          }),
          _vm._v("この求人を気になるリストに保存している会員\n    "),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }